// extracted by mini-css-extract-plugin
export default {"leagueSingle":"LeaguesCard_leagueSingle__zpX41","leagueItem":"LeaguesCard_leagueItem__TbQ6p"};